import React, { useEffect, useState } from 'react'
function Header() {
 
    return (
        <header id="header" className="fixed-top">
            <div className="container d-flex align-items-center">

                <div className="logo mr-auto">
                    <a href="#" style={{ fontSize: 22, fontWeight: "bold", color: "#27bd76" }}>Abdul Saboor</a>
                </div>

                <nav className="nav-menu  d-lg-block ">
                    <ul className="font-weight-bold">
                        {/* <li className="active"><a href="/">Home</a></li>
                        <li><a href="#about" >About</a></li>
                        <li><a href="#services">Service</a></li>
                        <li><a href="#projects" >Projects</a></li>
                        <li><a href="#contact">Contact</a></li> */}
                        <li className="get-started"><a href="/cv/cv.pdf" target="_blank" rel="noopener noreferrer" download="cv.pdf">Resume</a></li>
                    </ul>
                </nav>

            </div>
        </header>
    )
}

export default Header